import React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48",
  ...props,
  children: /*#__PURE__*/_jsxs("g", {
    fill: "currentColor",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M24.6 4.6c-.5 0-1.2 0-1.8.1-3.6-2-11.3-2.9-15.5-2.7-.5 0-.9.3-1.1.8s-.1 1 .2 1.4c1.8 2 2.8 4.6 2.9 7.3-1.6 1.8-2.8 3.8-3.7 6.1h-3c-1.4 0-2.6 1.2-2.6 2.6V28c0 1.4 1.2 2.6 2.6 2.6h2.3c1.1 4 3.5 7.6 6.8 10.2v4c0 .7.6 1.3 1.3 1.3h6.5c.7 0 1.3-.6 1.3-1.3v-1.3h6.5v1.3c0 .7.6 1.3 1.3 1.3H35c.7 0 1.3-.6 1.3-1.3v-3.1c.2-.1.4-.3.6-.3 4.4-3.3 7.2-8 7.9-13.4.8-5.4-.6-10.7-3.9-15.1-3.8-5.2-9.9-8.3-16.3-8.3zm17.7 22.9c-.7 4.7-3.1 8.9-6.9 11.7-.1.1-.4.2-.6.4l-.3.2c-.4.2-.7.7-.7 1.1v2.6h-3.9v-1.3c0-.7-.6-1.3-1.3-1.3h-9.1c-.7 0-1.3.6-1.3 1.3v1.3h-3.9v-3.3-.1c0-.1 0-.2-.1-.3v-.1c-.1-.2-.2-.4-.4-.5-3.2-2.5-5.6-6-6.6-10.1l-.1-.2c-.2-.5-.7-.9-1.2-.9H2.6v-7.8h3.9c.6 0 1.1-.4 1.2-.9 1.3-3.9 3.9-7.2 7.4-9.4.6-.4.8-1.2.4-1.8-.4-.6-1.2-.8-1.8-.4-.8.5-1.5 1-2.1 1.6-.3-1.7-.9-3.3-1.7-4.7 4.1.1 9.2 1 11.7 2.3.3.3.6.4 1 .4.6 0 1.5-.1 2.1-.1 5.5 0 10.9 2.7 14.2 7.1 2.8 3.8 4 8.4 3.4 13.2zM46.7 20.1c-.7 0-1.3.6-1.3 1.3v3.9c0 .7.6 1.3 1.3 1.3S48 26 48 25.3v-3.9c0-.7-.6-1.3-1.3-1.3z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M27.1 9.9c-.7-.1-1.4.4-1.5 1.1-.1.7.4 1.4 1.1 1.5 5.4.9 9.6 5.1 10.5 10.5.1.6.7 1.1 1.3 1.1h.2c.7-.1 1.2-.8 1.1-1.5C38.7 16 33.6 11 27.1 9.9z"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "15.6",
      cy: "18.2",
      r: "1.9"
    })]
  })
});